import {
  Chip,
  Stack,
  Select,
  MenuItem,
  Typography,
  Box,
  SelectChangeEvent,
} from "@mui/material";
import { FilterOption, ActiveFilter } from "../types";

interface FilterChipsProps<T extends ActiveFilter> {
  availableFilters: FilterOption[];
  extraFilters: T[];
  onChange: (filters: T[]) => void;
}

export default function FilterChips<T extends ActiveFilter>({
  availableFilters,
  extraFilters,
  onChange,
}: FilterChipsProps<T>) {
  const updateValue = (key: string, value: any) => {
    onChange(extraFilters.map((f) => (f.key === key ? { ...f, value } : f)));
  };

  const removeFilter = (key: string) => {
    onChange(extraFilters.filter((f) => f.key !== key));
  };

  if (extraFilters.length === 0) return null;

  return (
    <Stack useFlexGap direction="row" spacing={1} flexWrap="wrap" mt={2}>
      {extraFilters.map((filter) => {
        const options =
          availableFilters.find((f) => f.key === filter.key)?.values || [];
        return (
          <Chip
            key={filter.key}
            label={
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">{filter.label}:</Typography>
                <Select
                  variant="standard"
                  size="small"
                  value={filter.value}
                  onChange={(e: SelectChangeEvent<any>) =>
                    updateValue(filter.key, e.target.value)
                  }
                  sx={{
                    fontSize: "0.875rem",
                    "& .MuiSelect-select": { padding: "2px 6px" },
                    borderRadius: "4px",
                    backgroundColor: "grey.300",
                    "&.MuiInputBase-root:before, &.MuiInputBase-root:after": {
                      borderBottom: "none !important",
                    },
                  }}
                >
                  {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      <Typography variant="body2">{opt.label}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            }
            onDelete={() => removeFilter(filter.key)}
            variant="outlined"
          />
        );
      })}
    </Stack>
  );
}
